import { useTranslate } from '@tolgee/react';
import { StatusIcon } from './StatusIcon';
import { useMemo } from 'react';
import { OnlineStatus } from 'services/api/assistant.account';

interface UserCurrentStatusProps {
  currentOnlineStatus: OnlineStatus;
}

export const UserCurrentStatus = (props: UserCurrentStatusProps) => {
  const { currentOnlineStatus } = props;
  const { t } = useTranslate();

  const { status, subStatus } = currentOnlineStatus;

  const label = useMemo(() => {
    if (status === 'HANGUP' && subStatus) {
      return subStatus;
    }

    return status ? t(`status.${status.toLowerCase()}`) : '';
  }, [t, status, subStatus]);

  return (
    <div
      className="flex items-center gap-0.5 py-1 px-1.5 rounded-2xl whitespace-nowrap bg-[var(--fett-sider-item-active-bg)]"
      title={label}
    >
      <StatusIcon status={status} />
      <span className="max-w-[36px] text-xs whitespace-nowrap overflow-hidden text-ellipsis">
        {label}
      </span>
    </div>
  );
};
